
import {userApi} from './user'


export const getUserByEmailApi = userApi.injectEndpoints({
  endpoints: (builder) => ({
    getUserByEmail: builder.query({
      query: ( email) => `/email?email=${email}`,
      providesTags: (result, error, email) => [{ type: 'Email' }],
    }),
    

  }),
  overrideExisting: false,
})

export const { useGetUserByEmailQuery, usePrefetch } = getUserByEmailApi